const PUBLIC_AUTH_PATHS = new Set(["/login", "/auth/callback"]);

export function isPublicAuthRoute(pathname: string): boolean {
  return PUBLIC_AUTH_PATHS.has(pathname);
}
